module.exports = __webpack_public_path__ + "static/media/barcode-white.c55c299e.svg";